module.exports = __webpack_public_path__ + "img/thumbnail_Siamang_f_normal.e119c434.png";